var subModule = angular.module('ikeweb.subscription', []);
require('./subscription.action.service');
require('./subscription.state.service');


var subscriptionStateFactory = require('../../../shared/subscription.state.factory');

subModule.factory('subscriptionStateFactory', function() {
    return subscriptionStateFactory;
});



//////////////////
// WEBPACK FOOTER
// ./src/client/components/subscription/subscription.module.js
// module id = 408
// module chunks = 0